import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './procurementDetail.css';

/**
 * Collapsible card that holds one group of requirement sections. The body is
 * hidden rather than unmounted, so editors and date pickers keep their state
 * and the section anchors stay in the DOM for the side navigation.
 */
const RequirementGroup = ({
  id,
  icon,
  title,
  summary,
  chip,
  isOpen,
  onToggle,
  children,
}) => (
  <section id={id} className={classnames('pd-group', { 'is-open': isOpen })}>
    <button
      type='button'
      className='pd-group__head'
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-controls={`${id}-body`}
    >
      <span className='pd-group__icon' aria-hidden='true'>
        <i className={icon} />
      </span>
      <span className='pd-group__titles'>
        <span className='pd-group__title'>{title}</span>
        {summary && <span className='pd-group__summary'>{summary}</span>}
      </span>
      {chip}
      <i
        className='ri-arrow-down-s-line pd-group__chevron'
        aria-hidden='true'
      />
    </button>
    <div id={`${id}-body`} className='pd-group__body' hidden={!isOpen}>
      {children}
    </div>
  </section>
);

RequirementGroup.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  summary: PropTypes.node,
  chip: PropTypes.node,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default RequirementGroup;
